export default {
  title: 'Sprog',
  save_changes: 'Gem ændringer',
};
